import clsx from 'clsx';

import { Sticker, StickerProps } from '../sticker';
import { forwardRef } from 'react';

export type ProductTagsProps = {
  tags: { label: string; variant: StickerProps['variant'] }[];
  variant: 'pdp' | 'plp' | 'pdp_new';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'base';
  hasMargins?: boolean;
};

export const ProductTags = forwardRef<HTMLDivElement, ProductTagsProps>(
  (
    { tags, variant, size = 'md', hasMargins = true }: ProductTagsProps,
    ref
  ) => {
    if (!tags) return null;

    return (
      <div
        className={clsx({
          'absolute top-2 left-2 z-10 flex items-start flex-wrap min-h-[29px]':
            variant === 'plp',
          'flex mb-1 print:hidden': variant === 'pdp',
          'flex gap-2 print:hidden': variant === 'pdp_new',
        })}
        ref={ref}
      >
        {tags.map((tag) => (
          <Sticker
            variant={tag.variant}
            key={tag.label}
            size={size}
            hasMargins={hasMargins}
          >
            {tag.label}
          </Sticker>
        ))}
      </div>
    );
  }
);
